import React, { useContext, useState } from 'react';
import { scrollTo, getTextColorClass, getColor } from '@utils/Utils';
import { BasicData } from '@App';

import './style.scss';
import { useScrollPosition } from '@utils/hooks/useScrollPosition';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronsUp } from '@fortawesome/pro-regular-svg-icons';

const BackToTop = () => {
    const { theme } = useContext(BasicData);
    const [show, setShow] = useState(false);

    const colors = getColor(theme);

    useScrollPosition(({currPos}) => {
        if (currPos.y > 0) {
         setShow(true)
        } else {
         setShow(false)
        }
 
     }, [show], null, true)

    return (
        <div style={{borderColor : getTextColorClass(colors?.primary) === 'light-text' ? '#FFF' : '#5E5873'}} onClick={() => scrollTo()} className={`back-to-top${show ? ' show' : ''}`}>
            <FontAwesomeIcon icon={faChevronsUp} className={getTextColorClass(colors?.secondary)} size="xl" width={24} />
        </div>
    )
}

export default BackToTop